import { pick } from "accept-language-parser";
import { cleanDoubleSlashes, parseURL } from "ufo";

import { needToNormalize, normalizeUrl } from "~/shared/utils/normalize-url";

export const supportedLngs: Array<LanguageCode> = ["zh", "en"];
export const fallbackLng = "zh";
export default {
  // This is the list of languages your application supports
  supportedLngs,
  // This is the language you want to use in case
  // if the user language is not in the supportedLngs
  fallbackLng,
  // The default namespace of i18next is "translation", but you can customize it here
  defaultNS: "common",
};

function getFromSupported(language: string | null): LanguageCode {
  return (
    pick(supportedLngs, language ?? fallbackLng, { loose: true }) ?? fallbackLng
  );
}

export const detectLanguageAndRegion = (
  request: Request,
): { language: LanguageCode } => {
  const { pathname } = parseURL(request.url);
  const [_, lng] = pathname.split("/");

  return {
    language: getFromSupported(typeof lng === "string" ? lng : null),
  };
};

export const changeLanguage = (locale: LanguageCode): void => {
  if (typeof window === "undefined") {
    throw new Error('"changeLanguage" is client-only method');
  }

  const pathname = location.pathname;
  const [_, _lng, ...otherSegments] = pathname.split("/");
  const newPath = [locale, ...otherSegments].join("/");
  let href = `${cleanDoubleSlashes(`/${newPath}/`)}${location.search ? `${location.search}` : ""}${location.hash ? `${location.hash}` : ""}`;

  if (needToNormalize(href)) {
    href = normalizeUrl(href);
  }
  location.href = href;
};

export const generateUrlWithLocale = (
  path: string,
  locale: LanguageCode,
): string => {
  const { search, hash, pathname } = parseURL(path);
  let url = `/${locale}/${pathname}${search ? `?${search}` : ""}${hash ? `?${hash}` : ""}`;
  if (needToNormalize(url)) {
    url = normalizeUrl(url);
  }
  return url;
};
